import { observer } from 'mobx-react-lite';

import { useDisconnect, useHandleConnectClick } from 'hooks';
import { store } from 'store';
import { cutAddress } from 'utils/helpers';

import * as S from './WalletButton.styles';

export const WalletButton = observer(() => {
  const { handleConnectClick } = useHandleConnectClick();
  const { disconnect } = useDisconnect();

  const { account } = store.web3Store;

  if (!account) {
    return <S.Root onClick={handleConnectClick}>Connect wallet</S.Root>;
  }

  return (
    <S.Root $isConnected onClick={() => disconnect()}>
      <S.Dot />
      {cutAddress(account)}
    </S.Root>
  );
});
